<template>
  <div class="mac">
    <v-row class="py-10 mb-16" align="center" justify="center">
      <div class="pc">
        <v-card
          class="overflow-y-auto"
          max-height="270"
          max-width="460"
        >
          <img src="../assets/Capture.png" width="460">
        </v-card>
      </div>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'MacCarousel',

    data () {
      return {
      }
    },
  }
</script>

<style scoped>
.mac{
  background-image: url(../assets/pc.png);
  background-position: center bottom -10px;
  padding-top:30px;
}

.pc{
  position: relative;
  top: -30px;
}

</style>
